import React from "react";

const ScenariosGrid = ({ title, subtitle, scenarios }) => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-3xl font-bold text-brand-blue mb-4 text-center">{title}</h2>
                {subtitle && (
                    <p className="text-center text-gray-500 text-lg max-w-2xl mx-auto mb-12">{subtitle}</p>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {scenarios.map((s, i) => (
                        <div key={i} className="bg-white shadow rounded-lg p-6 border border-gray-200 text-center hover:shadow-lg transition-shadow">
                            <div className="text-4xl mb-3">{s.icon}</div>
                            <h3 className="font-semibold text-gray-900 mb-2 text-sm">{s.title}</h3>
                            <p className="text-gray-500 text-xs">{s.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ScenariosGrid;
